import type { Address } from "@repo/types";

export const addressRepo = {
  init: (data?: Partial<Address>) => {
    return {
      type: "",
      street: "",
      street2: "",
      city: "",
      state: "PA",
      zip: "",
      country: "",
      ...data,
    };
  },
};
